export default __webpack_public_path__ + "static/media/contractor.f8f70600.svg";